module.exports = __webpack_public_path__ + "img/battle_60x60.78f30cf3.png";